import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.jit || initialState;

export const selectJit = createSelector([selectDomain], jitState => jitState);
